export default __webpack_public_path__ + "static/media/anabelle2.ea4d0d71.jpg";